import React from "react";

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  backgroundColor: "#fff",
  border: "1px solid #ccc",
  fontSize: "0.9rem",
};

const headerStyle = {
  backgroundColor: "#f4f4f4",
  color: "#000",
  border: "1px solid #ccc",
  padding: "8px",
};

const cellStyle = {
  border: "1px solid #ccc",
  padding: "8px",
};

const containerStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  padding: "16px",
  marginTop: "20px",
  borderRadius: "6px",
  width: "90%",
  maxWidth: "1000px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
};

const AdminBookings = ({ bookings }) => {
  return (
    <div style={containerStyle}>
      <h3
        style={{
          marginTop: "0",
          marginBottom: "10px",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        Admin - Current Bookings
      </h3>

      {bookings.length === 0 ? (
        <p style={{ textAlign: "center" }}>No bookings yet.</p>
      ) : (
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={headerStyle}>Ref Code</th>
              <th style={headerStyle}>Customer</th>
              <th style={headerStyle}>Driver</th>
              <th style={headerStyle}>Pickup</th>
              <th style={headerStyle}>Dropoff</th>
              <th style={headerStyle}>Status</th>
              <th style={headerStyle}>Fare (£)</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((b) => (
              <tr key={b.booking_id}>
                <td style={cellStyle}>{b.ref_code}</td>
                <td style={cellStyle}>{b.customer_name}</td>
                <td style={cellStyle}>{b.driver_name}</td>
                <td style={cellStyle}>{b.pickup_location}</td>
                <td style={cellStyle}>{b.dropoff_location}</td>
                <td style={cellStyle}>{b.status}</td>
                <td style={cellStyle}>{b.fare}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminBookings;

